/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Term_L7Inputs */

const en_mk_term_l7 = /** @type {(inputs: Mk_Term_L7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✔ AC-1 test   2.8s  pnpm test — 24 passed`)
};

const id_mk_term_l7 = /** @type {(inputs: Mk_Term_L7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✔ AC-1 test   2.8s  pnpm test — 24 lulus`)
};

/**
* | output |
* | --- |
* | "✔ AC-1 test 2.8s pnpm test — 24 passed" |
*
* @param {Mk_Term_L7Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_term_l7 = /** @type {((inputs?: Mk_Term_L7Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Term_L7Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_term_l7(inputs)
	return en_mk_term_l7(inputs)
});